/**
 * Sleep for a given amount of time in milliseconds.
 */
export const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));
